// Hook odpowiedzialny za pobranie pojedynczego artykułu z bazy wiedzy
// Używa endpointu listy artykułów i filtruje po ID

import { useMemo } from 'react';
import { useGetKnowledgeBaseArticles } from 'api/endpoints/useGetKnowledgeBaseArticles';

export const useGetKnowledgeBaseArticle = (articleId: number) => {
  // Pobranie wszystkich artykułów
  const { data: articlesData, isLoading, error, ...rest } = useGetKnowledgeBaseArticles({
    page: 1,
    limit: 999
  });

  // Znalezienie pojedynczego artykułu po ID
  const article = useMemo(() => {
    return articlesData?.items?.find((item) => item.id === articleId);
  }, [articlesData?.items, articleId]);

  return {
    data: article,
    isLoading,
    error,
    ...rest
  };
};

